import { render } from "./g-titulo-steps.vue?vue&type=template&id=49fb980b&scoped=true"
import script from "./g-titulo-steps.vue?vue&type=script&lang=js"
export * from "./g-titulo-steps.vue?vue&type=script&lang=js"

import "./g-titulo-steps.vue?vue&type=style&index=0&id=49fb980b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fb980b"]])

export default __exports__